import React from 'react'
import { PUBLIC_URL } from '../config/settings/environment'
import BrandLayout from '../components/Layouts/BrandLayout'
import FooterSectionContainer from '../containers/FooterSection/FooterSection.container'
import { Image404, Root, Text } from './NotFound.styles'
import { Button } from '@chilecompra/react-kit/components'

/**
 * The NotFound' page.
 */
const NotFound = () => (
  <BrandLayout footer={<FooterSectionContainer />}>
    <Root>
      <Image404 alt="Mercado Público" src={`${PUBLIC_URL}/assets/images/logo_mercadopublico.svg`} />
      <Text>
        Para hacer uso del Convenio Marco de Pasajes debes ingresar a través de la plataforma de Mercado&nbsp;Público.
      </Text>
      <Button color="primary" size="large">
        Ir&nbsp;a&nbsp;Mercado&nbsp;Público
      </Button>
    </Root>
  </BrandLayout>
)

export default NotFound
